<template>
   <v-container
    fill-height
    fluid    
  >
    <v-row>
      <v-col
        xs="12"
      >
        <v-card>
          <v-card-text>
            <v-row>
              <v-col xs="1">
                <v-avatar color="teal">
                  <span class="white--text headline">{{user.name.charAt(0)}}</span>
                </v-avatar>
              </v-col>

              <v-col xs="1">
                <span><strong>{{user.name}}</strong></span><br/>
                <span><strong>{{user.email}}</strong></span>
                <span><strong>{{user.created_at}}</strong></span>
              </v-col>
            </v-row>
            
            <!-- <v-form
              ref="form"
              v-model="valid"
              lazy-validation
            >
              <v-text-field
                v-model="user.monetizze_postback_key"
                :rules="rules.monetizze_postback_key"
                label="Chave de postback da Monetizze"
                required
              ></v-text-field>
              <v-btn
                :disabled="!valid"
                color="success"
                @click="validate"
              >
                Atualizar
              </v-btn>
            </v-form> -->
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import axios from 'axios';
export default {

  name: 'Profile',
  created () {
    this.fetchUser();
  },
  methods: {
    validate () {
      if (this.$refs.form.validate()) {
        this.updateUserProfile();
      }
    },
    fetchUser () {
      const self = this;      
      axios({
        method: 'get',
        url: '/api/user',
        baseURL: process.env.VUE_APP_API_BASE_URL,
        headers: {
          Accept: 'application/json',
          Authorization: 'Bearer ' + localStorage.getItem('access_token')
        },
      })
      .then( function (response) {
        self.user = response.data;
      })
      .catch( function (err) {
        
      })
    },
    updateUserProfile () {
      const self = this;
      axios({
        method: 'put',
        url: '/api/user',
        baseURL: process.env.VUE_APP_API_BASE_URL,
        headers: {
          Accept: 'application/json',
          Authorization: 'Bearer ' + localStorage.getItem('access_token')
        },
        data: {
          monetizze_postback_key: self.user.monetizze_postback_key
        }
      })
      .then( function (response) {
        self.$store.commit('setUser', {data: response.data});
      })
      .catch (function (err) {
        if (err && err.response && err.response.status === 500) {
          alert("Esta chave já está sendo utilizada");
        }
        
      });
    }
  },
  data () {
    return {
      valid: true,
      user: {
        created_at: "",
        eduzz_api_key: "",
        eduzz_public_key: "",
        email: "",
        email_verified_at: "",
        id: "",
        monetizze_postback_key: "",
        name: "",
        updated_at: "",
      },
      rules: {
        monetizze_postback_key: [
          v => !!v || 'A chave é obrigatória',
          v => (v && v.length >= 32) || 'A chave deve possuir no mínimo 32 caracteres'
        ]
      }
    }
  }
}
</script>

<style lang="css" scoped>
</style>